'use client';

/**
 * Repurchase Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { AdvantagesSection } from '../common/advantages-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { MapPin, UserPlus, RefreshCw, Users, TrendingUp } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.repurchasePlan.hero"
                imageSrc="/images/mlm-plans/repurchase_animate.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.repurchasePlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
                descriptionKeys={['description1', 'description2', 'description3']}
            />
            <FeaturesSection plan={plan} translationNamespace="planDetails.repurchasePlan.features" />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.repurchasePlan.whySoftware" />
            <CommissionsSection
                plan={plan}
                translationNamespace="planDetails.repurchasePlan.commissions"
                commissions={[
                    { icon: MapPin, color: 'primary', titleKey: 'position.title', descriptionKey: 'position.description' },
                    { icon: UserPlus, color: 'blue', titleKey: 'sponsor.title', descriptionKey: 'sponsor.description' },
                    { icon: RefreshCw, color: 'green', titleKey: 'repurchase.title', descriptionKey: 'repurchase.description' },
                    { icon: Users, color: 'purple', titleKey: 'repurchaseRepurchase.title', descriptionKey: 'repurchaseRepurchase.description' },
                    { icon: TrendingUp, color: 'orange', titleKey: 'matching.title', descriptionKey: 'matching.description' },
                ]}
                gridCols="3"
                hasDescription={true}
            />
            <AdvantagesSection
                plan={plan}
                translationNamespace="planDetails.repurchasePlan.advantages"
                advantageKeys={['advantage1', 'advantage2', 'advantage3', 'advantage4', 'advantage5', 'advantage6', 'advantage7', 'advantage8']}
                gridCols="3"
            />
        </div>
    );
}

